import React from 'react'
import GoogleSearchAd from './GoogleSearchAd'

const GoogleAdsetForm = ({ dataItem, onChange }) => {
    return (
        <div className='row mt-2'>
            <div className='col-6'>
                <div className="row">
                    <div className="col-6 mt-2">
                        <label htmlFor="finalUrl" > Final Url *  </label>
                        <input
                            type="text"
                            name="finalUrl"
                            placeholder="Enter Description"
                            className="form-control form-control-sm"
                            value={dataItem.finalUrl}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6 mt-2">
                        <label htmlFor="description" > Description *  </label>
                        <input
                            type="text"
                            name="description"
                            placeholder="Enter Description"
                            className="form-control form-control-sm"
                            value={dataItem.description}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6 mt-2">
                        <label htmlFor="headline_part1" > Headline Part 1 *  </label>
                        <input
                            type="text"
                            name="headline_part1"
                            placeholder="Enter Headline Part 1"
                            className="form-control form-control-sm"
                            value={dataItem.headline_part1}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6 mt-2">
                        <label htmlFor="headline_part2" > Headline Part 2 *  </label>
                        <input
                            type="text"
                            name="headline_part2"
                            placeholder="Enter Headline Part 2"
                            className="form-control form-control-sm"
                            value={dataItem.headline_part2}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6 mt-2">
                        <label htmlFor="sitelinks">Site links *</label>
                        <input
                            type="text"
                            name="sitelinks"
                            placeholder="Enter comma-separated sitelinks"
                            className="form-control form-control-sm"
                            value={dataItem.sitelinks}
                            onChange={onChange}
                        />
                        <small className="form-text text-muted">Enter comma-separated sitelinks</small>
                    </div>
                </div>
            </div>
            <div className='col-6'>
                <GoogleSearchAd finalUrl={dataItem?.finalUrl} headline1={dataItem?.headline_part1} headline2={dataItem?.headline_part2} description={dataItem?.description} sitelinks={dataItem?.sitelinks ? dataItem?.sitelinks?.split(',').map(s => s.trim()).filter(Boolean) : []} />
            </div>
        </div>
    )
}

export default GoogleAdsetForm